var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mcenter",staticStyle:{"margin-top":"25vh"}},[_c('van-toast',{attrs:{"id":"van-toast"}}),_c('van-image',{attrs:{"width":"70","height":"70","round":"","src":require('@/assets/img.png')}}),_c('div',{staticClass:"mcenter mt20 font15"},[_vm._v("建信服务")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }